import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Handover } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-home-content-inbox-general',
  templateUrl: './home-content-inbox-general.component.html',
  styleUrls: ['./home-content-inbox-general.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentInboxGeneralComponent implements OnInit {
  @Input() handoversGeneral: Handover[] | undefined;
  @Input() totalHandoversGeneral: number | undefined;
  @Output() reloadGeneral = new EventEmitter<boolean>();
  @Output() reorder = new EventEmitter<string>();
  @Output() handoversGeneralWithFilter = new EventEmitter<string>();

  optionsOrder = [
    { value: 'desc', viewValue: 'Del más nuevo al mas viejo' },
    { value: 'asc', viewValue: 'Del mas viejo al mas nuevo' },
  ];
  selectedValue = 'desc';
  destinationLabel = 'De';
  textSearch = '';

  constructor() {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  eventReload(reload: boolean) {
    this.reloadGeneral.emit(true);
  }

  reorderHandovers(event: MatSelectChange): void {
    this.reorder.emit(event.value);
  }

  getHandoversHomeGeneralWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversGeneralWithFilter.emit(searchText);
  }
}
